import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
export const PremisesSelect = ({ id = 'uprn', name = 'uprn', easting, northing, value, selectedUprn, onChange, disabled = false, className = 'structure-form__input structure-form__select', }) => {
    const [premises, setPremises] = useState([]);
    const [selectedPremise, setSelectedPremise] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        const controller = new AbortController();
        const params = new URLSearchParams({
            easting: String(easting),
            northing: String(northing),
        });
        if (selectedUprn)
            params.set('selectedUprn', selectedUprn);
        setLoading(true);
        setError(null);
        fetch(`/structure/nearest-premises?${params.toString()}`, {
            headers: { Accept: 'application/json' },
            signal: controller.signal,
        })
            .then(async (response) => {
            const result = await response.json().catch(() => ({}));
            if (!response.ok) {
                throw new Error(result.error || 'Unable to load nearby premises');
            }
            setPremises(result.premises || []);
            setSelectedPremise(result.selectedPremise || null);
        })
            .catch(fetchError => {
            if (fetchError.name !== 'AbortError') {
                setError(fetchError.message || 'Unable to load nearby premises');
            }
        })
            .finally(() => {
            if (!controller.signal.aborted)
                setLoading(false);
        });
        return () => controller.abort();
    }, [easting, northing, selectedUprn]);
    const options = useMemo(() => {
        if (!selectedPremise || premises.some(premise => premise.uprn === selectedPremise.uprn)) {
            return premises;
        }
        return [selectedPremise, ...premises];
    }, [premises, selectedPremise]);
    return (_jsxs(_Fragment, { children: [_jsxs("select", { id: id, name: name, className: className, value: value, onChange: event => onChange(event.target.value), disabled: disabled || loading, children: [_jsx("option", { value: "", children: loading ? 'Loading nearest premises…' : 'No premises selected' }), options.map(premise => (_jsxs("option", { value: premise.uprn, children: [premise.address, " (", premise.uprn, ")"] }, premise.uprn)))] }), error && _jsx("div", { className: "structure-form__error", children: error })] }));
};
export default PremisesSelect;
